import React from "react";

import { css } from "@emotion/css";
import { desktop, laptop, tablet } from "../../../styles/breakpoints";
import { Link } from "react-router-dom";
import buttons from "../../../styles/buttons";
import { useI18n } from "../../../i18n";

const App = () => {
  const { t } = useI18n();
  return (
    <div className={style.main}>
      <video
        className={`desktop`}
        autoPlay
        loop
        muted
        playsInline
        webkit-playsinline
      >
        <source
          src="/videos/app.mp4"
          type="video/mp4"
        />
      </video>
      <div className={style.container}>
        <div className="wrapper">
          <h2>
            {t("home_app_ready")}
            <br />
            {t("home_app_boost")}
            <br />
            {t("home_app_arch")}
          </h2><Link
              className={buttons.secondary}
              to={"/subscribe"}
            >
              {t("home_join_waitlist")}
            </Link>
          {/* <div>
            <Clickable>
              <img src={IOS} alt="" className="store-image" />
            </Clickable>
            <Clickable>
              <img src={GGPS} alt="" className="store-image" />
            </Clickable>
          </div> */}
        </div>
      </div>
    </div>
  );
};

const style = {
  main: css({
    position: "relative",
    height: 1024,
    overflow: "hidden",

    video: {
      position: "absolute",
      width: "100%",
      height: "100%",
      objectFit: "cover",
      left: 0,
      top: 0,
      zIndex: "0",
    },
    [desktop]: {
      height: 1400,
    },
    [laptop]: {
      height: 1024,
    },
    [tablet]: {
      height: 626,
    },
  }),
  container: css({
    height: "100%",
    display: "flex",
    flexDirection: "column",
    alignContent: "center",
    flexWrap: "nowrap",
    justifyContent: "center",
    alignItems: "center",
    margin: "auto",
    maxWidth: 1172,

    ".store-image": {
      backdropFilter: "blur(6px)",
      borderRadius: 20,
    },
    h2: {
      color: "#fff",
      textAlign: "center",
      fontFamily: "Syne",
      fontSize: 78.172,
      fontStyle: "normal",
      fontWeight: 700,
      lineHeight: "77.848px",
      marginBottom: 45,
    },
    ".wrapper": {
      display: "flex",
      flexDirection: "row",
      flexWrap: "wrap",
      alignContent: "center",
      justifyContent: "center",
      alignItems: "center",
      gap: 31,
      maxWidth: 589,
      zIndex: 1,
      marginBottom: 100,
      marginLeft: 0,
      marginRight: 0,

      div: {
        display: "flex",
        flexDirection: "row",
        flexWrap: "nowrap",
        alignContent: "center",
        justifyContent: "center",
        alignItems: "center",
        gap: 15,
      },
    },
    [desktop]: {
      maxWidth: 1025,
      alignContent: "center",
      justifyContent: "flex-end",
      alignItems: "center",

      h2: {
        textAlign: "center",
        fontSize: 92.487,
        lineHeight: "95.27px",
        marginBottom: 25,
      },
      ".wrapper": {
        gap: 31,
        maxWidth: 589,
        marginBottom: 100,
      },
    },
    [laptop]: {
      maxWidth: 1025,

      h2: {
        fontSize: 67.198,
        lineHeight: "69.219px",
        marginBottom: 15,
      },
      ".wrapper": {
        gap: 31,
        maxWidth: 589,
        marginBottom: 60,

        img: {
          width: 199.994,
          height: 80.024,
        },
      },
    },
    [tablet]: {
      h2: {
        fontSize: 42,
        lineHeight: "43.263px",
      },
      ".wrapper": {
        gap: 31,
        maxWidth: 327,
        marginBottom: 40,

        img: {
          width: 125,
          height: 50.017,
        },
      },
    },
  }),
};

export default App;
